import dayjs, { type Dayjs } from "dayjs"
import timezonePlugin from "dayjs/plugin/timezone"
import utc from "dayjs/plugin/utc"

import {
  WALL_CLOCK,
  parseActivityMoment
} from "../../containers/Lead/LeadWorkspacePage/activity/lead-activity-date.ts"

dayjs.extend(utc)
dayjs.extend(timezonePlugin)

/**
 * The instant behind a date the API rendered in the account's own format and
 * timezone (`TimezoneFormattingMixin`, e.g. "09/10/2026 12:39 PM" on a
 * DD/MM/YYYY account). A bare `dayjs(value)` reads that month-first: 9 October
 * becomes 10 September, and a day past the 12th does not parse at all.
 * A true ISO instant (with a zone designator) is read as one.
 */
export function readAccountInstant(
  value: unknown,
  dateFormat: string | null | undefined,
  timezone: string | null | undefined
): Dayjs | null {
  const wallClock = parseActivityMoment(value, dateFormat, timezone)
  if (!wallClock) return null
  if (!timezone) return wallClock
  try {
    return dayjs.tz(wallClock.format(WALL_CLOCK), timezone)
  } catch {
    // The backend accepts zone names this browser may not know.
    return wallClock
  }
}
